export default {
  slug: 'maria-rockola',
  basepath: 'content/gallery-maria-rockola/',
  images: [
    { width: 1199, height: 800, file: '_dsc9143.jpg', name: '' },
    { width: 1199, height: 800, file: '_dsc9142.jpg', name: '' },
    { width: 1199, height: 800, file: '_dsc9140.jpg', name: '' },
    { width: 1199, height: 800, file: '_dsc9141.jpg', name: '' },
    { width: 1199, height: 800, file: '_dsc9145.jpg', name: '' },
    { width: 1199, height: 800, file: '7-monica-merares-denise-rivas.jpg', name: 'Mónica Merares y Denise Rivas' },
    { width: 1199, height: 800, file: '2.1-gerardo-araya.jpg', name: 'Gerardo Araya' },
    { width: 1199, height: 800, file: '4-juan-pablo-ortega-felipe-martinez.jpg', name: 'Juan Pablo Ortega y Felipe Martínez' },
    { width: 1199, height: 800, file: '_dsc9144.jpg', name: '' },
    { width: 1199, height: 800, file: '2-gerardo-arata.jpg', name: 'Gerardo Arata' },
    { width: 1199, height: 800, file: '3-christian-aguirre-francisca-escobar.jpg', name: 'Christian Aguirre y Francisca Escobar' },
    { width: 1199, height: 800, file: '1-carol-olavarria.jpg', name: 'Carol Olavarría' },
    { width: 1199, height: 800, file: '_dsc9147.jpg', name: '' },
    { width: 1199, height: 800, file: '6-sebastian-vargas-catalina-vicuna.jpg', name: 'Sebastián Vargas y Catalina Vicuña' },
    { width: 1199, height: 800, file: '8-fernando-guzman-claudia-heredia.jpg', name: 'Fernando Guzmán y Claudia Heredia' },
    { width: 1199, height: 800, file: '5.2-maria-ignacia-concha-gannina-gentili.jpg', name: 'María Ignacia Concha y Gannina Gentili' },
    { width: 1199, height: 800, file: '5-maria-ignacia-concha-gannina-gentili.jpg', name: 'María Ignacia Concha y Gannina Gentili' },
    { width: 1199, height: 800, file: '7.2-monica-merares-denise-rivas.jpg', name: 'Mónica Merares y Denise Rivas' },
    { width: 1199, height: 800, file: '_dsc9161.jpg', name: '' },
    { width: 1199, height: 800, file: '_dsc9160.jpg',  name: '' }
  ]
}
